export enum MasterSchedule {
QELeadQualityofEarnings_Template1 = 1,
PLLeadProfitandLossandSupportingSchedules_Template1 = 2,
BSLeadBalanceSheetandsupportingSchedules_Template1 = 3,
WCWorkingCapital_Template1 = 4,
CFFreeCashFlow_Template1 = 5,
LeadPFPL_Template1 = 6,
QELeadQualityofEarnings_Template2 = 7,
PLLeadProfitandLossandSupportingSchedules_Template2 = 8,
BSLeadBalanceSheetandsupportingSchedules_Template2 = 9,
WCWorkingCapital_Template2 = 10,
CFFreeCashFlow_Template2 = 11,
QELeadQualityofEarnings_Template3 = 12,
PLLeadProfitandLossandSupportingSchedules_Template3 = 13,
BSLeadBalanceSheetandsupportingSchedules_Template3 = 14,
WCWorkingCapital_Template3 = 15,
CFFreeCashFlow_Template3 = 16
}





